module.exports = __webpack_public_path__ + "img/3.69e4dc78.jpg";